import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const EmployeeDashboard = ({ dashboardStats }) => {
    if (!dashboardStats) return null;

    return (
        <Row className="mb-4">
            <Col md={3}>
                <Card className="text-center h-100">
                    <Card.Body>
                        <h3 className="text-primary">{dashboardStats.overview.totalEmployees}</h3>
                        <p className="text-muted mb-0">Toplam Personel</p>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="text-center h-100">
                    <Card.Body>
                        <h3 className="text-success">{dashboardStats.overview.activeEmployees}</h3>
                        <p className="text-muted mb-0">Aktif Personel</p>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="text-center h-100">
                    <Card.Body>
                        <h3 className="text-warning">{dashboardStats.overview.onLeaveEmployees}</h3>
                        <p className="text-muted mb-0">İzinli Personel</p>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="text-center h-100">
                    <Card.Body>
                        <h3 className="text-danger">{dashboardStats.overview.expiringContracts}</h3>
                        <p className="text-muted mb-0">Sözleşmesi Biten</p>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default EmployeeDashboard;